module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idPan"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "95%",
      "margin-top": "0px",
      "margin-left": "0px",
      "border": "0px solid red",
      "display": "flex"
    }
  }, [_c('div', {
    ref: "idPath",
    staticStyle: {
      "float": "left",
      "width": "500px",
      "height": "40px",
      "line-height": "40px",
      "text-indent": "10px",
      "border": "1px solid #bbbbbb"
    }
  }), _vm._v(" "), _c('input', {
    ref: "idImgFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".mp4,.avi,.jpg,.png"
    },
    on: {
      "change": _vm.onImgChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "4px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onFileClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("选择文件")))]), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "float": "left",
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "4px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onUploadClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("上传")))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "95%",
      "height": "18px",
      "margin-top": "2px",
      "margin-left": "0px"
    }
  }, [_c('div', {
    ref: "idProgPan",
    staticStyle: {
      "float": "left",
      "width": "500px",
      "height": "12px",
      "border-radius": "5px",
      "border": "1px solid #2a83cf",
      "display": "none",
      "position": "relative"
    }
  }, [_c('div', {
    ref: "idProgBar",
    staticStyle: {
      "position": "absolute",
      "width": "0%",
      "height": "10px",
      "line-height": "10px",
      "border-radius": "5px",
      "background": "#b4ea74"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idProgCapt",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "10px",
      "line-height": "10px",
      "color": "#2a83cf",
      "text-align": "center",
      "font-size": "8px",
      "font-style": "italic"
    }
  })])])]), _vm._v(" "), _c('div', {
    ref: "idTablePan",
    staticStyle: {
      "width": "100%",
      "border": "0px solid red",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('ctable', {
    attrs: {
      "ctrl": _vm.ctrlTable
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a7fbb90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/adInfo.vue
// module id = 771
// module chunks = 1